/**
 * Step 4 of the bed configurator ("Choose Footboard Treatment").
 *
 * The keys below are the internal `storage` values. They are load-bearing — they map to the Threekit
 * `Storage` boolean, are joined into the backend style lookup as `${shape} ${storage}`, drive the SKU
 * branch in addSkuForBed, derive the tile image filename, and are persisted in saved configurations.
 * Renaming a key breaks all of the above, so customer-facing wording lives only in the values here.
 */
export const FOOTBOARD_TREATMENT_LABELS = {
  "No Drawer": "High Leg Bed",
  "No Legs No Drawer": "Standard Bed",
  "End Drawer": "Storage Bed",
} as const;

export const getFootboardTreatmentLabel = (storage: string): string =>
  FOOTBOARD_TREATMENT_LABELS[storage as keyof typeof FOOTBOARD_TREATMENT_LABELS] ?? storage;
